"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAvatarStack = exports.formatNumberOfItems = void 0;
var react_1 = require("react");
function formatNumberOfItems(items) {
    return items < 1000 ? items.toString() : "".concat((items / 1000).toFixed(1), "k");
}
exports.formatNumberOfItems = formatNumberOfItems;
function useAvatarStack(_a) {
    var users = _a.users, avatars = _a.avatars, _b = _a.maxItems, maxItems = _b === void 0 ? 4 : _b, _c = _a.total, total = _c === void 0 ? 0 : _c;
    var avatarElements = react_1.Children.toArray(avatars);
    var items = users || avatarElements;
    var effectiveTotal = Math.max(items.length, total);
    var itemsCountToRenderIncludingPlus = Math.min(items.length, maxItems);
    var showPlus = effectiveTotal > itemsCountToRenderIncludingPlus;
    var itemsCountToRenderExcludingPlus = showPlus
        ? itemsCountToRenderIncludingPlus - 1
        : itemsCountToRenderIncludingPlus;
    var itemsToRender = items.slice(0, itemsCountToRenderExcludingPlus);
    return {
        showPlus: showPlus,
        items: itemsToRender,
        formattedNumberOfItems: formatNumberOfItems(effectiveTotal - itemsCountToRenderExcludingPlus),
    };
}
exports.useAvatarStack = useAvatarStack;
